import type { ListItemProps } from '@/components/atomic/atoms/data-display/list/item/typings';
import View from '@/components/atomic/atoms/layout/view/styled';
import styled, { CSSObject } from '@emotion/styled';

const ListItem = styled(View)<ListItemProps>(
	({ $inline, $paddingTop = 12, $paddingBottom = 12 }) => {
		let style: CSSObject = {
			paddingTop: $paddingTop,
			paddingBottom: $paddingBottom,
		};

		if ($inline) {
			style = {
				...style,
				display: 'inline-block',
			};
		}

		return style;
	},
).withComponent('li');

export default ListItem;
